/* eslint-disable no-unused-vars */
/* eslint-disable sonarjs/sonar-no-unused-vars */
/* eslint-disable sonarjs/no-dead-store */
/* eslint-disable no-underscore-dangle */
/* global google */

import React, { useEffect, useMemo, useState } from 'react';
import { Map as GoogleMap, useMap } from '@vis.gl/react-google-maps';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

import ReportMarker from './ReportMarker';
import Heatmap from './HeatMap';
import UserMarker from './UserMarker';

const ReportsMap = ({
  onSetMap,
  reports,
  projects,
  locations,
  onSelectReport,
  selectedReportId,
  setSelectedUserId,
  selectedUserId,
  heatmap,
  mapFilters,
}) => {
  const map = useMap();

  const [markers, setMarkers] = useState(() => new Map());
  const [hasInteracted, setHasInteracted] = useState(false);

  const bounds = new google.maps.LatLngBounds();

  useEffect(() => {
    if (!map) return;
    onSetMap(map);
  }, [map]);

  useEffect(() => {
    if (selectedReportId || selectedUserId) setHasInteracted(true);
  }, [selectedReportId, selectedUserId]);

  const customRenderer = {
    render: ({ count, position }) => {
      // 1. Create the HTML element for the cluster
      const container = document.createElement('div');
      container.className = 'custom-cluster'; // Link to your CSS
      container.innerHTML = `<span>${count}</span>`;

      return new google.maps.marker.AdvancedMarkerElement({
        // Use a custom image or SVG for the cluster icon
        content: container,
        position,
        // Ensure cluster stays on top of individual markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  };

  const clusterer = useMemo(() => {
    if (!map) return null;

    return new MarkerClusterer({
      map,
      renderer: customRenderer,
      algorithmOptions: {
        radius: 150, // Default is usually around 60-80px
        maxZoom: 14,
      },
      options: {
        zoomOnClick: false, // Stops the "random" jump
      },
      onClusterClick: (event, cluster) => {
        map.setZoom(map.getZoom() + 3);
        setTimeout(() => map.setCenter(cluster.position), 100);
      },
    });
  }, [map]);

  useEffect(() => {
    if (!clusterer) return;

    clusterer.clearMarkers();
    clusterer.addMarkers([...markers.values()]);
  }, [clusterer, markers]);

  const position = { lat: 42.480665922076504, lng: 12.54341973845475 };

  const heatMapJson = useMemo(
    () =>
      heatmap
        ? reports
            .filter((rep) => rep.location)
            .map((rep) => ({
              lat: Number(rep.location.latitude) + 0.0,
              lng: Number(rep.location.longitude),
            }))
        : [],
    [heatmap, reports]
  );

  return (
    <div className="w-full h-[800px]">
      <GoogleMap
        defaultCenter={position}
        disableDefaultUI
        defaultZoom={10}
        mapId="reports.show"
        mapTypeId="terrain"
        onDragend={() => setHasInteracted(true)}
        minZoom={2}
        restriction={{
          latLngBounds: { north: 85, south: -85, west: -180, east: 180 },
          strictBounds: true,
        }}
      >
        {!heatmap &&
          mapFilters.includes('reports') &&
          reports?.map((report) => {
            if (!report.location?.latitude || !report.location?.longitude) {
              return null;
            }

            if (!hasInteracted && !selectedReportId && !selectedUserId) {
              bounds.extend({
                lat: Number(report.location.latitude),
                lng: Number(report.location.longitude),
              });
              map?.fitBounds(bounds);
            }
            return (
              <ReportMarker
                key={`report-marker-${report._id}`}
                report={report}
                map={map}
                onSelectReport={onSelectReport}
                selectedReportId={selectedReportId}
                setMarkers={setMarkers}
              />
            );
          })}
        {!heatmap &&
          mapFilters.includes('users') &&
          locations.map((user) => {
            if (!user.latitude || !user.longitude) {
              return null;
            }

            return (
              <UserMarker
                key={`report-marker-${user.user.id}`}
                user={user}
                project={projects.find((p) => p.id === user.user.project.id)}
                map={map}
                setSelectedUserId={setSelectedUserId}
                selectedUserId={selectedUserId}
                setMarkers={setMarkers}
              />
            );
          })}
        {heatmap && <Heatmap reports={heatMapJson} radius={100} opacity={0.8} />}
      </GoogleMap>
    </div>
  );
};

export default ReportsMap;
